module.exports = __webpack_public_path__ + "static/media/logo.5c0436d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logo.png
// module id = 62
// module chunks = 0